export default __webpack_public_path__ + "static/media/sar.bffb7376.png";